module.exports = __webpack_public_path__ + "static/media/4.05919fa2.jpg";